import { useEffect, useState, useRef, memo, useContext, ReactNode, Fragment } from 'react';
import {isEmpty} from 'bodycodi/cmap/app/js/common.js';
import {createPortal} from 'react-dom';
import {StateContext} from 'bodycodi/cmap/app/components/common/context';

import 'bodycodi/cmap/app/css/common/customDialog.css';

function CustomDialogWrap(prop: any){

    const body: HTMLBodyElement | null = document.querySelector('body')!;
    
    return createPortal(
        <CustomDialog {...prop} />,
        body
    );
}

type CustomDialogProp = {
    open: boolean;
    onClose: Function;
    className: string;
    children?: ReactNode;
  };

function CustomDialog({open, onClose, className="", children} : CustomDialogProp){
    
    const dialog = useRef<HTMLDivElement>(null);
    const [remove, setRemove] = useState(true);
    const [classNameDim, setClassNameDim] = useState("");
    const [timeout, setTimeout1] = useState<any>();
    const {state} = useContext(StateContext);

    useEffect(() => {
        if(open){
            clearTimeout(timeout);
            if(window.popHis.length === 1){
                document.getElementById("root")?.classList.add("pop-open");
            }
            setClassNameDim("open");
            setRemove(false);
        }else{
            //팝업이 떠있고(popLength) window.popHis.length == 0 (전부 닫음)일때
            let popLength = document.querySelectorAll("body .custom-dialog-wrap").length;
            setClassNameDim("close");
            if(window.popHis.length === 0 && popLength !== 0){
                document.getElementById("root")?.classList.remove("pop-open");
                document.getElementById("root")?.classList.add("pop-close");                
            }
            setTimeout1(setTimeout(() => {
                document.getElementById("root")?.classList.remove("pop-open");
                document.getElementById("root")?.classList.remove("pop-close");
                setRemove(true);
            }, 250));
        }
        return () => {
            clearTimeout(timeout);

        }
    }, [open]);
    
    useEffect(() => {
        return () => {
            clearTimeout(timeout);
            setTimeout(() => {
                document.getElementById("root")?.classList.remove("pop-open");
                document.getElementById("root")?.classList.remove("pop-close");
            }, 250);
        }
    }, [])
    
    return(
        <Fragment>
            {(!remove && !isEmpty(remove)) && (
                <div className={"custom-dialog-wrap "+classNameDim+(isEmpty(className)? "" : " "+className)} ref={dialog}>
                    <div className="custom-dialog-dim"></div>
                    <div className="custom-dialog-container">
                        {children}
                    </div>
                </div>  
            )}
        </Fragment>
    )
}

export default memo(CustomDialogWrap);